import { useContext, useEffect } from "react";
import { DashboardInfoContext, DashboardInfoPayload } from "../Context/dashboardContext";

export const useEnvironmentDetection = () => {
    const { setCurrentActiveEnvironment } = useContext(DashboardInfoContext) as DashboardInfoPayload;
    
    useEffect(() => {
        const host = globalThis.location.host;
        if (host === "devportal.instabrain.io") {
            setCurrentActiveEnvironment("Production");
        }
        else if (host === "devportal.instabrainstage.io") {
            setCurrentActiveEnvironment("Staging");
        }
        else if (host === "devportal.instabrain-dev.io" || host.includes("localhost")) {
            setCurrentActiveEnvironment("Development");
        }
    }, [])
};